import { GetDashboard, GetStatistics, GetProceduresStatisticsByDate, GetAvgMinsStatisticsByDate,
  GetPersonalProceduresByDate, GetPersonalAvgMinsByDate, GetPersonalScores, GetPersonalTotalProcedures } from '@/api/dashboard'

const dashboards = {
  state: {
    dashboard: [],
    statistics: [],
    proceduresStatistic: [],
    AvgMinsStatistic: [],
    hosPitalPercentage: []
  },
  mutations: {
    SET_DASHBOARD: (state, datas) => {
      state.dashboard = datas
    },
    GET_STATISTICS: (state, datas) => {
      state.statistics = datas
    },
    GET_PRODUCESTATISTICS: (state, datas) => {
      state.proceduresStatistic = datas
    },
    GET_AVGNINSSTATISTICS: (state, datas) => {
      state.AvgMinsStatistic = datas
    },
    GET_HOSPITALPERCENTAGE: (state, datas) => {
      state.hosPitalPercentage = datas
    }
  },
  actions: {
    GetDashboard({ commit }) { // 执行单列表
      return new Promise((resolve, reject) => {
        GetDashboard().then(response => {
          const data = response.data
          commit('SET_DASHBOARD', data.departments) // 执行单列表
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetStatistics({ commit }, data) { // 统计数据
      return new Promise((resolve, reject) => {
        GetStatistics(data).then(response => {
          const data = response.data
          commit('GET_STATISTICS', data)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetProceduresStatisticsByDate({ commit }, data) { // 获取按时间统计检查数
      return new Promise((resolve, reject) => {
        GetProceduresStatisticsByDate(data).then(response => {
          const data = response.data
          commit('GET_PRODUCESTATISTICS', data)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetAvgMinsStatisticsByDate({ commit }, data) { // 获取按时间统计平均诊断时间
      return new Promise((resolve, reject) => {
        GetAvgMinsStatisticsByDate(data).then(response => {
          const data = response.data
          commit('GET_AVGNINSSTATISTICS', data)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GethosPitalPercentage({ commit }, data) { // 获取各医院占比
      return new Promise((resolve, reject) => {
        GetStatistics(data).then(response => {
          const data = response.data
          commit('GET_HOSPITALPERCENTAGE', data)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // , , ,
    GetPersonalProceduresByDate({ commit }, data) { // 个人近30天或近一年诊断数量
      return new Promise((resolve, reject) => {
        GetPersonalProceduresByDate(data).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetPersonalAvgMinsByDate({ commit }, data) { // 个人按时间统计平均诊断时间
      return new Promise((resolve, reject) => {
        GetPersonalAvgMinsByDate(data).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetPersonalScores({ commit }, data) { // 个人按时间统计得分
      return new Promise((resolve, reject) => {
        GetPersonalScores(data).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetPersonalTotalProcedures({ commit }, data) { // 获取个人总统计
      return new Promise((resolve, reject) => {
        GetPersonalTotalProcedures(data).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default dashboards
